import { useEffect, useRef, useState } from "react";
import { useInitializeChargeMutation } from "@/store/charges/apis";

// Fwd payment intent
type PaymentIntent = {
  id: string;
  client_secret: string;
};

function GetCard({
  amount,
  handleToken,
  handlePaymentIntent,
  moverId,
}: {
  amount: number;
  handleToken: (token: string) => void;
  handlePaymentIntent?: (pi: PaymentIntent) => void;
  moverId: number;
}) {
  const [initializeCharge] = useInitializeChargeMutation();
  const [paymentIntent, setPaymentIntent] = useState<PaymentIntent | null>(
    null
  );
  const initialized = useRef(false);

  useEffect(() => {
    async function initializeCard() {
      if (initialized.current) return;
      initialized.current = true;

      const pi = await initializeCharge({
        amount: amount,
        mover_id: moverId,
      }).unwrap();

      setPaymentIntent(pi);
      if (handlePaymentIntent) {
        handlePaymentIntent(pi);
      }
      // await initFwdCardComponent();
    }

    initializeCard();
  }, []);

  useEffect(() => {
    async function initFwdCardComponent() {
      if (!paymentIntent) {
        return;
      }

      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const paymentForm = await (window as any).Forward.createPaymentElement({
          apiKey: "live_pkey_4ss8VO2bqjudp1Kquu3knhvGq0Nv24",
          clientSecret: paymentIntent.client_secret,
        });

        paymentForm.mount("#payment-form", {
          onReady: (tokenize: () => void) => {
            tokenize();
          },
          onSuccess: async ({ token }: { token: string }) => {
            handleToken(token);

            // const pm = await createPaymentMethod({
            //   move_id: move.id,
            //   token,
            //   payment_intent_id: paymentIntent.id,
            // }).unwrap();

            // if (handlePaymentMethod) {
            //   handlePaymentMethod(pm);
            // }
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onError: (error: any) => {
            console.error("Error initializing Forward payment:", error);
          },
        });
      } catch (error) {
        console.error("Error initializing Forward payment:", error);
      }
    }

    if (!paymentIntent) {
      return;
    }

    initFwdCardComponent();
  }, [paymentIntent]);

  // useEffect(() => {
  //   const paymentForm = document.getElementById("payment-form");
  //   if (!paymentForm) return;

  //   const observer = new MutationObserver((mutations) => {
  //     for (const mutation of mutations) {
  //       if (mutation.addedNodes.length) {
  //         const iframe = paymentForm.querySelector("iframe");
  //         if (iframe) {
  //           setCardInputReady(true);
  //           observer.disconnect();
  //           break;
  //         }
  //       }
  //     }
  //   });

  //   observer.observe(paymentForm, {
  //     childList: true,
  //     subtree: true,
  //   });

  //   return () => observer.disconnect();
  // }, []);

  if (!paymentIntent) {
    return null;
  }

  return <div id="payment-form" />;
}

export default GetCard;
